var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext3_1",
    x: 0.636719,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M13.1367 15.5C12.7225 15.5 12.3867 15.8358 12.3867 16.25C12.3867 16.6642 12.7225 17 13.1367 17H26.6367C27.0509 17 27.3867 16.6642 27.3867 16.25C27.3867 15.8358 27.0509 15.5 26.6367 15.5H13.1367Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M12.7617 18.5C12.5546 18.5 12.3867 18.6679 12.3867 18.875C12.3867 19.0821 12.5546 19.25 12.7617 19.25H27.0117C27.2188 19.25 27.3867 19.0821 27.3867 18.875C27.3867 18.6679 27.2188 18.5 27.0117 18.5H12.7617Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M22.8867 21.125C22.8867 20.9179 23.0546 20.75 23.2617 20.75H27.0117C27.2188 20.75 27.3867 20.9179 27.3867 21.125C27.3867 21.3321 27.2188 21.5 27.0117 21.5H23.2617C23.0546 21.5 22.8867 21.3321 22.8867 21.125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M23.2617 23C23.0546 23 22.8867 23.1679 22.8867 23.375C22.8867 23.5821 23.0546 23.75 23.2617 23.75H27.0117C27.2188 23.75 27.3867 23.5821 27.3867 23.375C27.3867 23.1679 27.2188 23 27.0117 23H23.2617Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M22.8867 25.625C22.8867 25.4179 23.0546 25.25 23.2617 25.25H27.0117C27.2188 25.25 27.3867 25.4179 27.3867 25.625C27.3867 25.8321 27.2188 26 27.0117 26H23.2617C23.0546 26 22.8867 25.8321 22.8867 25.625Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M23.2617 27.5C23.0546 27.5 22.8867 27.6679 22.8867 27.875C22.8867 28.0821 23.0546 28.25 23.2617 28.25H27.0117C27.2188 28.25 27.3867 28.0821 27.3867 27.875C27.3867 27.6679 27.2188 27.5 27.0117 27.5H23.2617Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M12.3867 22.25C12.3867 21.4216 13.0583 20.75 13.8867 20.75H19.8867C20.7151 20.75 21.3867 21.4216 21.3867 22.25V26.75C21.3867 27.5784 20.7151 28.25 19.8867 28.25H13.8867C13.0583 28.25 12.3867 27.5784 12.3867 26.75V22.25Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M14.6368 11C13.8083 11 13.1367 11.6716 13.1367 12.5H11.6079C10.3263 12.5 9.38672 13.5634 9.38672 14.75V28.25C9.38672 29.8509 10.6491 31.25 12.329 31.25H30.3867L30.3995 31.25C31.222 31.2431 31.8867 30.5742 31.8867 29.75V12.4999C31.8867 11.6715 31.2152 10.9999 30.3868 10.9999C27.6508 10.9998 25.6648 10.9999 22.9288 11C20.1648 11 17.4008 11.0001 14.6368 11ZM28.1656 14C28.5109 14 28.7995 14.2524 28.8702 14.5895C28.881 14.6412 28.8867 14.6949 28.8867 14.75V28.25C28.8867 29.0784 29.5583 29.75 30.3867 29.75H12.329C11.5325 29.75 10.8867 29.0784 10.8867 28.25V14.75C10.8867 14.3358 11.2096 14 11.6079 14H28.1656Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.42ddbffc.svg";
export { ForwardRef as ReactComponent };